import { render, staticRenderFns } from "./linkcomponent.vue?vue&type=template&id=fea886b0"
import script from "./linkcomponent.vue?vue&type=script&lang=js"
export * from "./linkcomponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports